import { CustomEventName, getAnalytics, logEvent } from 'firebase/analytics'

import { ENVIRONMENT } from '@/constants/env'
import { firebaseApp } from '@/main'

export const logFirebaseEvent = (
  eventName: CustomEventName<string>,
  eventParams: { [key: string]: unknown }
) => {
  if (!eventName) return
  if (ENVIRONMENT === 'development') return
  try {
    const analytics = getAnalytics(firebaseApp)
    logEvent(analytics, eventName, eventParams)
  } catch (e) {
    console.warn(e)
  }
}
